<template>
  <div class="">
    <div class="uk-container">
      <alert v-if="error_code" class="uk-alert-danger"
             :data="{title: error_message,
             html: error_code,
             closeable:true}"></alert>

      <div class="uk-form-horizontal  uk-form-width-large uk-margin-auto uk-margin-large-bottom uk-margin-medium-top" action="#">

      <div class = "login-logos uk-margin-auto">

        <img class="logo" src="https://aca-dashboard-media.s3.amazonaws.com/ACE_Enterprise_logo_proc.png" css="box-shadow: None !important;"/>
        <img class="logo" src="https://trainingvideocompliance.s3.amazonaws.com/ACE+KIR+HHC+2019.jpg" css="box-shadow: None !important;"/>

      </div>

          <button class="uk-button uk-button-secondary new-register-button" @click="$router.push('/create-user/')">Click Here to Register as a New User!</button>

      <!--<div id="login-form" class="uk-form-horizontal uk-form-width-large uk-margin-auto" action="#">-->
        <form-container form_title="Login" :fieldList="formFields" :resetSignal="resetSignal" @output="processFormData"
                        :success_message="success_message" :prop_errors="error_code"></form-container>


       <a class="login-option" href="/reset-password/">Forgot your password and/or username?</a>

      </div>




    </div>
  </div>
</template>

<script>
	import FloatFieldInput from "./theme/Input.vue"
	import formContainer from "./theme/formContainer.vue"
	import api from '../store/apicall.js'
  import alert from './theme/Alert.vue'
  import S3Image from "./theme/S3Image";

	export default {
		name: "login",
		components: {
          S3Image,
			FloatFieldInput,
			formContainer,
            alert,
		},
		data: function () {
			return {
				formFields: [
					['username'],
					['password'],
				],
				resetSignal: false,
				success_message: "Trying to login...",
				login_success: false,
				access_success: false,
				access_message: "No successful connection test was made.",
				submitted: false,
                error_message: "That didnt work. Please try one of the following options.",
                error_code: null,
                next: this.$route.query.next,
                // globalAlert: this.$store.state.globalAlert
                not_logged_in_error :false,
                isIE: false,
			}
		},
      mounted(){
          let _t = this;

        if (navigator.userAgent.indexOf('MSIE') !== -1
                || navigator.appVersion.indexOf('Trident/') > -1) {
          this.isIE = true
        }

		  // this.isIE = ((document.all) && (!isOpera)) && parseFloat(navigator.appVersion.split("MSIE ")[1].split(";")[0]);
          console.log("IE", this.isIE)
		  if (this.isIE) {
            _t.$store.dispatch('globalAlertCreate', {
              alert_title: "This site works best on other browsers!",
              alert_body: "Viewing this site on Internet Explorer is like driving a Ferari with a Ford Pinto Engine. It might work, but just barely. Please consider using a different browser.",
              alert_class: "uk-alert uk-alert-danger",
              alert_type: "not_logged_in",
              html: "<a href='http://outdatedbrowser.com/en'>Update My Browser</a>"
            }).then(function () {
              console.log("IE ALERT")
            })
          }


            if (this.$route.query.next) {
              _t.$store.dispatch('globalAlertCreate', {
                alert_title: "You are not logged in, so cant go there.",
                alert_body: "After you login, we will try to take you there.",
                alert_class: "uk-alert uk-alert-danger",
                alert_type: "not_logged_in"
              }).then(function () {
                console.log("ALERT CREATED")
              })
            }
          },
		methods: {
			processFormData: function (output) {
				this.submitted = true;
				console.log(output);
				let _t = this;

				function continueLogin(_t) {
					if (_t.$store.state.globalAlert.data) {
						if (_t.$store.state.globalAlert.data.alert_type == 'not_logged_in') {
							_t.$store.dispatch('globalAlertReset', {}).then(
									function () {
										console.log("RESET ALERT")
									}).catch(function (error) {
								console.log(error)
							})
						}
					}



          //THIS IS HACKY AS SHIIIIT.
          // WE HAVE A RACE CONDITION HERE WITH AUTH, SO IF YOU CHANGE PERMISSIONS SOMETIMES
          // IT WILL RETURN A 403 AS IT TRIES TO LOGIN BEFORE WE CAN UPDATE PERMISSIONS.
          // Obviously, this is not the right solution. It works for now. Fix later.

					if (_t.next) {
						window.location.href = '/dashboard/';
					} else {
						console.log("pushing to dashboard");
						window.location.href= '/dashboard/';
					}
				}

				_t.$store.dispatch('login', {'username': output.username, 'password': output.password}).then(() => {
					// _t.$connect();
					console.log("LOGIN RESPONSE", _t.$store.state.user)
					if (_t.$store.state.user.error) {
						_t.error_code = "<h3>Please try one of the following:</h3> <ul><li>Try again. Hey maybe you will remember right?</li><li>Reset your password using the button below. You will need the email tied to your account</li><li>Contact us! You can contact us via the CONTACT link in the menu.</li>"
						_t.resetSignal = true
					} else {
						continueLogin(_t)
					}

				}).catch(function (error) {
					console.log("ERROR", error)
					if (!error) {
						continueLogin(_t)
					} else {
						_t.error_code = error
					}

				}).then(function () {
					_t.resetSignal = false
				})

			},
			confirm_access: function () {
				let _t = this
				api.get('/accounts/health-check/').then(
						function (response) {
							_t.access_message = response;
							_t.access_success = true;
						}
				)
			}
		},
		computed: {
			pong: function () {
				if (this.$store.state.socket.message) {
					return this.$store.state.socket.message
				} else {
					return "Sending...Ping"
				}
			}
		},
	}
</script>

<style lang="less" scoped>


  @import "../assets/less/theme.less";

  .uk-form-horizontal {
    max-width: 100%;

    .uk-card {
      margin-bottom: 30px;
    }
  }

  a {
    color: white;
  }

  .login-logos {

    margin-bottom: 30px;

    .logo {
      width: 150px;
      padding: 0 25px;

      &:first-of-type {
        border-right: 1px solid @primary-3;
      }
    }
  }

 .login-option {
    margin-bottom:  16px;
 }

  a.login-option {
    color: @primary-3;
    /*margin-top: 20px;*/
  }



  .new-register-button {
    margin-bottom: 1.5em;
    border-bottom: 4px solid @danger;
  }

</style>
